/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TPublicSuburbanV1CreateRealtyRequest,
  TPublicSuburbanV1CreateRealtyModel,
  IMappers,
  TPublicSuburbanV1CreateRealtyResponse,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { ICreateSuburbanRealtyResponse } from '../../../entities/web/CreateSuburbanRealtyResponse';
import type { IErrorResponseSchema } from '../../../entities/schemas/ErrorResponseSchema';

export function createPublicSuburbanV1CreateRealtyModel(
  parameters: TPublicSuburbanV1CreateRealtyRequest,
): TPublicSuburbanV1CreateRealtyModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'price-estimator',
    pathApi: '/suburban/v1/create-realty/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IPublicSuburbanV1CreateRealtyOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TPublicSuburbanV1CreateRealtyRequest;
}

export async function fetchPublicSuburbanV1CreateRealty<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IPublicSuburbanV1CreateRealtyOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TPublicSuburbanV1CreateRealtyResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createPublicSuburbanV1CreateRealtyModel(parameters),
    config,
  )) as FetchResponse<TPublicSuburbanV1CreateRealtyResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as ICreateSuburbanRealtyResponse, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TPublicSuburbanV1CreateRealtyResponse>;
}
